
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.75 20.167c-.504 0-.936-.18-1.295-.539a1.765 1.765 0 01-.538-1.295V8.25H2.75v10.083h15.583v1.834H2.75zM6.417 16.5c-.505 0-.936-.18-1.295-.539a1.765 1.765 0 01-.539-1.294V4.583h4.584V2.75c0-.504.18-.936.538-1.295.36-.359.79-.538 1.295-.538h3.667c.504 0 .935.18 1.294.538.36.36.539.79.539 1.295v1.833h4.583v10.084c0 .504-.18.935-.538 1.294-.36.36-.79.539-1.295.539H6.417zM11 4.583h3.667V2.75H11v1.833z"}})])
          )
        }
      }
    